<template>
  <div class="wrapper-content w-100">
    <div class="row">
      <div class="col-12">
        <h1>Workflow</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-2">
        <div class="row">
          <div class="col-lg-12 col-6">
            <button class="btn d-block w-100 btn-info mt-4 mt-lg-0" @click="addWait">Add wait</button>
          </div>
          <div class="col-lg-12 col-6">
            <button class="btn d-block w-100 btn-success mt-4" @click="addAction">Add Action</button>
          </div>
          <div class="col-lg-12 col-6">
            <button class="btn d-block w-100 btn-danger mt-4" @click="addEvent">Add Event</button>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7">
        <h1 v-if="!list.length">Agrega elementos</h1>

        <draggable tag="ul" :list="list" :move="checkMove" class="list-group" handle=".handle">
          <li
            class="list-group-item mb-4"
            :class="element.component"
            v-for="(element, index) in list"
            :key="`draggable-${index}`"
          >
            <font-awesome-icon v-if="!element.removeDrag" class="handle" size="lg" icon="bars" />
            <font-awesome-icon v-if="!element.removeDelete" class="close" size="lg" icon="times" @click="removeAt(index)" />

            <span class="text">{{ element.name }}</span>
            <font-awesome-icon icon="question-circle" :title="help(element.component)" />

            <component
              :is="element.component"
              v-model="form[element.name]"
              :options="element.options"
            />
          </li>
        </draggable>
        <ul>
          <li v-for="(item, index) in list" :key="index">{{item}}</li>
        </ul>
        <button
          type="button"
          :disabled="!list.length"
          class="btn btn-primary button"
          @click="save"
        >Guardar</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmWait from '@/views/mvlmesa/draggable/elements/LmWait'
import LmAction from '@/views/mvlmesa/draggable/elements/LmAction'
import LmEvent from '@/views/mvlmesa/draggable/elements/LmEvent'

let id = 0
export default {
  name: 'handle',
  display: 'Handle',
  instruction: 'Drag using the handle icon',
  order: 5,
  components: {
    draggable,
    LmButton,
    LmTextInput,
    LmWait,
    LmAction,
    LmEvent
  },
  data () {
    return {
      list: [
        {
          removeDrag: true,
          removeDelete: true,
          name: 'Event',
          id,
          component: 'LmEvent',
          options: {
            disabledOption: 'Seleccione un evento',
            content: ['El usuario se loguea', 'El usuario se des-loguea']
          },
          action () {
            alert('event')
          }
        }
      ],
      form: {}
    }
  },
  methods: {
    checkMove (event) {
      return event.draggedContext.futureIndex !== 0
    },
    help (componentName) {
      switch (componentName) {
        case 'LmWait':
          return 'Configura el lapso de tiempo que debe pasar para que la acción sea ejecutada'
        case 'LmAction':
          return 'Configura la acción a ejecutarse'
        case 'LmEvent':
          return 'Configura el evento, es decir, cuando se va a ejecutar la acción'
      }
    },
    removeAt (index) {
      this.list.splice(index, 1)
    },
    addWait () {
      id++
      this.list.push({
        name: 'Wait',
        id,
        component: 'LmWait',
        options: {
          disabledOption: 'Seleccione un lapso de tiempo',
          content: ['1seg', '2seg']
        },
        timeToWait: '1000'
      })
    },
    addAction () {
      id++
      this.list.push({
        name: 'Action',
        id,
        component: 'LmAction',
        options: {
          disabledOption: 'Seleccione una acción',
          content: ['Enviar email', 'Enviar push notification']
        },
        action () {
          alert('alert')
        }
      })
    },
    addEvent () {
      id++
      this.list.push({
        name: 'Event',
        id,
        component: 'LmEvent',
        options: {
          disabledOption: 'Seleccione un evento',
          content: ['El usuario se loguea', 'El usuario se des-loguea']
        },
        action () {
          alert('event')
        }
      })
    },
    save () {
      console.log('save')
    }
  }
}
</script>
<style lang="sass" scoped>
  .list-group-item
    color: white
    &.LmWait
      border-color: #17a2b8
      background: #17a2b8
    &.LmAction
      border-color: #28a745
      background: #28a745
    &.LmEvent
      border-color: #dc3545
      background: #dc3545
    .text
      margin: 20px 10px 20px 20px
      font-weight: bold
      font-size: 16px
    .close
      color: white
      opacity: 1
      cursor: pointer
    .handle
      cursor: grab
</style>
